<template>
  <div class="dk--input-holder" :class="{ 'dk--answered': message.answered, 'dk--input-error': error }">
    <input
        type="text"
        class="dk--input"
        placeholder="kirjoita tähän..."
        v-model="answer"
        :name="'dk__bot_input_' + message.ID"
        :disabled="message.answered"
        :class="{ 'dk--answered': message.answered }"
        @keyup.enter="this.sendAnswer"
        @input="checkValue"
    >

    <span
        class="hidden dk--bot-send-button"
        @click="this.sendAnswer"
    >
        <svg class="dk--bot-send-button-icon" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
          <!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
          <path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"/>
        </svg>
    </span>

    <span v-if="error" class="dk--input-error-msg">
      {{ error }}
    </span>

    <span v-if="message.answered" class="dk--input-value">{{ answer }}</span>
  </div>
  <button @click="this.sendAnswer" class="dk--bot-btn" v-if="!message.answered">
    Lähetä
  </button>
</template>

<script>
import { store } from "@/store";

export default {
  name: "DkBotInput",
  props: {
    message: Object,
  },
  data() {
    return {
      store,
      answer: '',
      error: null,
    }
  },
  methods: {
    sendAnswer() {
      if (!this.checkValue()) {
        return;
      }

      this.store.sendAnswer(this.message.ID, this.answer);
    },
    checkValue() {
      if (this.answer === '') {
        this.error = 'Unohdit kirjoittaa vastauksesi!';
        //this.store.messages[this.message.ID].error = 'empty_value';

        return false;
      }

      this.error = null;
      //this.store.messages[this.message.ID].error = null;

      return true;
    }
  }
}
</script>

<style lang="scss">

.dk--bot-btn {
  background-color: var(--dk--bot-answer-bg-color);
  color: var(--dk--bot-answer-color);
  border: 1px solid var(--dk--bot-answer-border-color);
  border-radius: var(--dk--bot-answer-border-radius);
  font-size: var(--dk--bot-msg-font-size) !important;
}

.dk--input-holder {
  box-sizing: border-box;
  display: flex;
  position: relative;
  max-width: 240px;
  width: 100%;
  z-index: 1;
  min-height: var(--dk--bot-answer-height);
  border: 1px solid var(--dk--bot-answer-border-color);
  opacity: 1;
  transition: var(--dk--bot-answered-transition);
  border-radius: var(--dk--bot-answer-border-radius);
  background-color: var(--dk--bot-answer-bg-color);

  input.dk--input {
    width: 100%;
    min-height: var(--dk--bot-answer-height);
    background-color: transparent;
    color: var(--dk--bot-answer-color);
    padding: 0;
    margin-left: 20px;
    border-radius: 0;
    border: none;
    font-family: var(--dk--bot-font-family);
    font-size: calc(var(--dk--bot-msg-font-size) * 0.9);
    opacity: 1;
    transition: var(--dk--bot-answered-transition);

    &:focus-visible {
      outline: 0;
    }

    &::placeholder {
      color: var(--dk--bot-input-placeholder-color);
      transition: var(--dk--bot-answered-transition);
      font-size: calc(var(--dk--bot-msg-font-size) * 0.9);
    }

    @media (min-width: 768px) {
      &,
      &::placeholder {
        font-size: calc(var(--dk--bot-msg-font-size--lg) * 0.9);
      }
    }
  }

  &.dk--answered {
    background-color: var(--dk--bot-answered-bg-color);
    transition: var(--dk--bot-answered-transition);
    width: auto;
    max-width: unset;
    min-width: var(--dk--bot-answer-min-width);
    justify-content: center;
    align-items: center;

    .dk--input-value {
      color: var(--dk--bot-answered-color);
      padding: 0 11px;
      box-sizing: border-box;
      height: var(--dk--bot-answer-height);
      line-height: var(--dk--bot-answer-height);
    }
  }

  &.dk--input-error {
    border: 1px solid red;
  }

  .dk--input-error-msg {
    display: none;
    position: absolute;
    left: 0;
    bottom: -10px;
    right: 0;
    color: red;
  }

  .dk--bot-send-button {
    /*width: 50px;
    position: relative;*/


    width: 60px;
    position: relative;
    font-size: 11px;
    display: flex;
    align-items: center;
    /*border-left: 1px solid #f00;*/
    cursor: pointer;
    color: rgb(57, 119, 15);
    letter-spacing: 0em;
    font-weight: bolder;


    .dk--bot-send-button-icon {
      display: none;

      /*fill: var(--dk--bot-answer-color);
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      padding: 10px;
      height: var(--dk--bot-answer-height);

      cursor: pointer;
      transition: var(--dk--bot-answered-transition);*/
    }
  }

  &.dk--answered .dk--bot-send-button,
  &.dk--answered .dk--input {
    display: none;
  }
}

/*input.dk--input.dk--answered,
input.dk--input.dk--answered:disabled, {
  color: var(--dk--bot-answered-color) !important;
  -webkit-text-fill-color: var(--dk--bot-answered-color) !important;
  transition: var(--dk--bot-answered-transition) !important;
  cursor: default;
}*/
</style>